// SAM-729 — which booking a payment belongs to. The payments feed (/business_access/payments/{id})
// carries the gateway reference but not the booking; the booking row stores the same reference in
// `payment_reference` (SAM-193), so the two join on it.

export type BookingRef = { id: string; code: string };

type BookingLike = { id: string; confirmation_code?: string | null; payment_reference?: string | null };

/** payment_reference → the booking it paid for. Bookings without a reference are skipped. */
export function bookingsByPaymentReference(bookings: BookingLike[] | undefined): Map<string, BookingRef> {
  const map = new Map<string, BookingRef>();
  for (const b of bookings ?? []) {
    const ref = b.payment_reference?.trim();
    if (!ref || !b.id) continue;
    map.set(ref, { id: b.id, code: b.confirmation_code || '' });
  }
  return map;
}

/** Deep link the Bookings page already understands (SAM-608): /bookings?booking=<id>&business=<id>. */
export function bookingHref(bookingId: string, businessId?: string): string {
  const params = new URLSearchParams({ booking: bookingId });
  if (businessId) params.set('business', businessId);
  return `/bookings?${params.toString()}`;
}

/** A pass's short reference for a table cell (the first block of its id). */
export function passShortRef(passId: string | number): string {
  return String(passId).split('-')[0].slice(0, 8);
}
